var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": ".98rem" } },
    [
      _c("topbar", { attrs: { text: "心理咨询设置协议" } }),
      _vm._v(" "),
      !_vm.showStatus
        ? _c("div", { staticClass: "mainBox" }, [
            _vm.companyId != 10002
              ? _c("div", { staticClass: "fff" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("心理咨询设置协议")
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "1.协议双方通过签署本协议以规范心理咨询的过程,保证心理咨询的有效进行。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "2.咨询形式可自由选择。每次咨询50分钟，每周咨询1次。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "3.咨询对象为在校全日制学生。咨询仅限本人使用，为一对一个别咨询，不得转介给他人或者在咨询过程中将他人拉入咨询。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "4.来访者请准时在预约时间接受咨询，迟到不延迟咨询时间，咨询准时结束。来访者如要改变或取消咨询时间, 请及时在系统中操作，否则将取消已经获得的咨询资格。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "5.咨询师如需改变或取消已经预约好的咨询时间,须提前通知来访者。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "6.来访者若选择网络咨询，在开始前尽量保证稳定的网络条件、通讯设备以及独立安静的房间，因网络故障或者不可抗力因素导致咨询质量受损，咨询时间无法延长或更改。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "7.来访者不得对咨询过程进行录音录像，也不得在咨询过程中攻击、辱骂咨询师或传播不良、非法信息，否则咨询师有权立刻终止咨询，并保留依法申诉的权利。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "8.在心理咨询过程中,咨询师要为来访者的隐私保密,来访者在咨询过程中所叙述的经历,体验,未经其本人同意,咨询师不得公布或传播这些信息.如确因学术交流或其他因素的需要,要报告该案例,需隐去可能辨认出来访者的个人信息。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "9．如来访者的行为可能对自己或他人构成严重伤害,或出于司法原因作为呈堂证供，则咨询师可以突破保密原则，向有关单位报告来访者的情况。除此之外，咨询记录将妥善保存在本中心，不提供给包括来访者在内的任何人与机构。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "10.来访者需要提供一位紧急联系人，并保证信息的真实、准确、有效性。在紧急情况下（如来访者存在危及自身或他人生命的情况等），心理中心可能与联系人取得联系，通报来访者的状况，但不会将来访者的隐私内容透露给该联系人。如果来访者提供的联系人信息为无效信息，由此导致的一切后果均将由来访者本人承担，与咨询师、心理中心及学校无关。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "11.心理咨询中心仅提供涉及学习生活、个人成长和自我发展类的相关问题心理评估和咨询，不提供包括精神鉴定、诊断、处方精神类药物、出具资格证明、对严重心理障碍患者的长程心理治疗等在内的服务内容。如果来访者可能患有某种精神障碍，请先去相关专科医院就诊就治。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "read" }, [
                    _vm._v("以上全部规定，本人已经阅读，并愿意遵守！")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.companyId == 10002
              ? _c("img", {
                  attrs: {
                    src: require("assets/xlfgt.png"),
                    id: "xlfgt",
                    alt: ""
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "inputBigBox" }, [
              _c("div", { staticClass: "inputBox" }, [
                _c("div", { staticClass: "word" }, [_vm._v("紧急联系人")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.emergencyContact,
                      expression: "emergencyContact"
                    }
                  ],
                  attrs: { type: "text", placeholder: "请输入联系人姓名" },
                  domProps: { value: _vm.emergencyContact },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.emergencyContact = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inputBox" }, [
                _c("div", { staticClass: "word" }, [_vm._v("与来访者关系")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.relation,
                      expression: "relation"
                    }
                  ],
                  attrs: { type: "text", placeholder: "如：母女" },
                  domProps: { value: _vm.relation },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.relation = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inputBox" }, [
                _c("div", { staticClass: "word" }, [_vm._v("紧急联系人电话")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.emergencyContactPhone,
                      expression: "emergencyContactPhone"
                    }
                  ],
                  attrs: { type: "text", placeholder: "请输入联系人电话" },
                  domProps: { value: _vm.emergencyContactPhone },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.emergencyContactPhone = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inputBox" }, [
                _c("div", { staticClass: "word" }, [_vm._v("来访者签名")]),
                _vm._v(" "),
                _vm.visitorSignature
                  ? _c("img", {
                      attrs: {
                        src: _vm.EnvUrl + _vm.visitorSignature,
                        alt: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.aa()
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.visitorSignature
                  ? _c("input", {
                      attrs: { type: "text", placeholder: "点击签名" },
                      on: {
                        click: function($event) {
                          _vm.aa()
                        }
                      }
                    })
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "c-btnBox" }, [
              _c(
                "div",
                {
                  staticClass: "btn",
                  class: {
                    active:
                      _vm.emergencyContact &&
                      _vm.relation &&
                      _vm.emergencyContactPhone &&
                      _vm.visitorSignature
                  },
                  on: { click: _vm.read }
                },
                [_vm._v("我已阅读并同意遵守")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showStatus,
              expression: "showStatus"
            }
          ],
          staticClass: "signatureBox"
        },
        [
          _c("div", { ref: "canvasHW", staticClass: "canvasBox" }, [
            _c("canvas", {
              ref: "canvasF",
              on: {
                touchstart: _vm.touchStart,
                touchmove: _vm.touchMove,
                touchend: _vm.touchEnd,
                mousedown: _vm.mouseDown,
                mousemove: _vm.mouseMove,
                mouseup: _vm.mouseUp
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "btnBox" }, [
              _c("button", { on: { click: _vm.overwrite } }, [_vm._v("重写")]),
              _vm._v(" "),
              _c("button", { on: { click: _vm.saveWrite } }, [
                _vm._v("提交签名")
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2681052a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2681052a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/agreement.vue
// module id = null
// module chunks = 